import { IReservation } from '../shared/interfaces/reservation.interfaces';
import { ApiService } from '../shared/services/api-service/api.service';
import { IPaymentInitRequestPayload, IPaymentInitResponse } from './interfaces/payment-init.interfaces';

class PaymentInitServiceClass {
    private static _instance: PaymentInitServiceClass;
    public static get instance() {
        return this._instance || (this._instance = new this());
    }
    private constructor() { }

    /**
     * Method to initiate payment
     * @param hotelCode
     * @param reservationList
     * @param languageCode
     * @returns
     */
    async initiatePayment(hotelCode: number, reservationList: IReservation[], languageCode: string,
        currencyCode?: string, tcShareLocation?: boolean) {
        const paymentInitRequestPayload = this._buildHoldReservationRequestPayload(reservationList, languageCode);
        try {
            const paymentInitApiResponse: Response = await ApiService.initiatePayment(hotelCode, paymentInitRequestPayload,
                currencyCode, tcShareLocation);
            const paymentInitResponse: IPaymentInitResponse = await paymentInitApiResponse.json();
            return paymentInitResponse;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Method to build payment init payload
     * @param reservationList
     * @param languageCode
     * @returns
     */
    private _buildHoldReservationRequestPayload(reservationList: IReservation[], languageCode: string): IPaymentInitRequestPayload {
        const payload: IPaymentInitRequestPayload = {
            'languageCode': languageCode,
            'reservationRequestParams': JSON.parse(JSON.stringify(reservationList))
        };
        payload.reservationRequestParams.forEach((reservation) => {
            delete reservation['hotelInfo'];
            delete reservation['merchandisedPromoData'];
            delete reservation['isPeStrikeThroughEnabled'];
            delete reservation['merchandisedCurrencyExchgRate'];
            delete reservation['isMerchandisedBooking'];
            delete reservation['policies'];
            if (reservation['roomStays'] && reservation['roomStays'].length) {
                reservation['roomStays'].forEach((roomStay) => {
                    delete roomStay.total;
                    delete roomStay.taxes;
                    delete roomStay.prodTaxes;
                    if (roomStay.roomRates && roomStay.roomRates.length) {
                        roomStay.roomRates.forEach((roomRate) => {
                            delete roomRate.rates;
                        });
                    }
                });
            }
        });
        return payload;
    }

}

export const PaymentInitService = PaymentInitServiceClass.instance;
